import { render, staticRenderFns } from "./AgentTransactionsReportLawMatterList.vue?vue&type=template&id=c976c4c2&"
import script from "./AgentTransactionsReportLawMatterList.vue?vue&type=script&lang=js&"
export * from "./AgentTransactionsReportLawMatterList.vue?vue&type=script&lang=js&"
import style0 from "./AgentTransactionsReportLawMatterList.vue?vue&type=style&index=0&id=c976c4c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports